import React, { useEffect } from 'react';
import {bindActionCreators, Dispatch} from 'redux';
import './App.scss';
import {BrowserRouter, Redirect, Route, Switch} from "react-router-dom";
import { RootState } from './reducers';
import * as actions from './actions/generalActions';
import {logOutLocally} from './actions/generalActions';

import Login from './containers/Login/Login';
import Dashboard from './containers/Dashboard/Dashboard';
import SuperAdminRoutes from './containers/SuperAdmin/SuperAdminRoutes';
import ImpersonationLandingPage from './containers/SuperAdmin/Impersonation/ImpersonationLandingPage';
import ImpersonationBanner from './containers/SuperAdmin/Impersonation/ImpersonationBanner';
import { getActiveBearerToken } from './utils/apiCaller';
import { connect } from 'react-redux';
import { Protected } from './auth/ProtectedRoute';
import ResetPassword from './containers/ResetPassword/ResetPassword';
import LandingPage from './containers/LandingPage/LandingPage'
import {toast} from "react-toastify";

interface Props {
	user: any;
	app: any;
	history:any;
	actions:any;
	authenticate:any;
	loading: boolean;
	intl:any;
}

const App: React.FC<Props> = (props) => {

	// Prefer the impersonation bearer (sessionStorage, per-tab) over the
	// god-user's own tenant token (localStorage, shared across tabs). Without
	// this the landing-redirected tab authenticates as the god-user's tenant
	// identity instead of the impersonated user, which defeats the point.
	const token = getActiveBearerToken();
	useEffect(() => {
		if(token) {
			props.actions.authenticate(token).then(res => {
				if(!res) {
					props.actions.isAuthenticated(false)
					props.history.push('/login')
				} else {
					props.actions.isAuthenticated(true)
					props.actions.fetchCompanyProfile()
					// Hard-reload of a deep route used to drop the navbar's
					// module links until the user clicked something else,
					// because permissions were only fetched inside per-page
					// useEffects. Dispatching at boot covers every route in
					// one place — per-page calls still run as a refresh.
					props.actions.getUserPermissionsAndResponsibilities()
				}
			})
		}
	}, []);

	return (
		<BrowserRouter>
			{/* Mounted once at root so the red banner survives route changes
			    for any tab carrying an imp_access_token. No-op for normal tabs. */}
			<ImpersonationBanner />
			<Switch>
				<Route
					exact
					path="/"
					component={LandingPage}
				/>

				<Route
					exact
					path="/reset-password/:token/:email"
					component={ResetPassword}
				/>

				<Route
					exact
					path="/login"
					component={Login}
				/>

				{/* Impersonation handoff landing page — public (OTX is the credential)
				    so it must sit OUTSIDE the Protected wildcard. */}
				<Route
					exact
					path="/impersonation/landing"
					component={ImpersonationLandingPage}
				/>

				{/* Super-admin ("Mika Ops") panel. Separate auth tier, separate session
				    namespace, distinct shell. Must be declared BEFORE the Protected
				    wildcard below, which otherwise catches every unmatched path. */}
				<Route path="/mika/ops" component={SuperAdminRoutes} />

				<Protected path="/" component={Dashboard}/>

				<Route
					exact
					path="/impression/client-creation"
					component={Login}
				/>
			</Switch>
		</BrowserRouter>
	);
}

function mapStateToProps(state: RootState, ownProps: any) {
	return {
		...ownProps,
		...state.app,
        user: state.user,
	}
}

function mapDispatchToProps(dispatch: Dispatch<actions.ACTION>) {
	return {
        actions: bindActionCreators(actions as any, dispatch),
		logOutLocally: bindActionCreators(logOutLocally, dispatch),
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(App)
